import api from "../../../../../../api";
import utils from "../../../../../../utils";
import values from "../../../../../../values";
import Context from "../../../../../../context";
import Cookies from "js-cookie";
import CustomDropDownSearch from "../../../../../../components/CustomDropDownSearch";

import { useQuery } from "react-query";
import { ICreateStudent } from "../../../../../../types/student.interface";
import {
  CustomButton2,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomView,
} from "../../../../../../components";

import React, { useContext, useState } from "react";
import {
  ICompanyItem,
  IOnSearchUser,
} from "../../../../../../types/common.interface";
import { financialGroup } from "../../../../../../validators";
import { CYCLE } from "../../../../../../values/dropdownItems";
import { useTranslation } from "react-i18next";

type Props = {
  defaultValues: ICreateStudent;
  onSubmit: (event: ICreateStudent) => void;
};

const CompanyStudentRelations = (props: Props) => {
  // ** ===========================================================================================================
  // **                                            Values Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { isLoading } = React.useContext(Context.StudentScreen);
  const [selectedCity, setSelectedCity] = useState<any>(props?.defaultValues?.city);
  const [selectedParent, setSelectedParen] = useState<any>(
    props?.defaultValues?.parent
  );
  const [selectedDriver, setSelectedDriver] = useState<any>(
    props?.defaultValues?.driver
  );
  const [selectedSchool, setSelectedSchool] = useState<any>(
    props?.defaultValues?.school
  );
  const [selectedProvince, setSelectedProvince] = useState<any>(
    props?.defaultValues?.province
  );
  const [selectedCycle, setSelectedCycle] = React.useState<any>(
    props?.defaultValues?.cycle);
  const [selectedArea, setSelectedArea] = React.useState<any>(props?.defaultValues?.area);
  const [selectedNeighborhood, setSelectedNeighborhood] = React.useState<any>(
    props?.defaultValues?.neighborhood
  );

  const [searchedValueParent, setSearchedValueParent] =
    React.useState<IOnSearchUser>();
  const [searchedValueSchool, setSearchedValueSchool] =
    React.useState<IOnSearchUser>();
  const [searchedValueCompany, setSearchedValueCompany] =
    React.useState<IOnSearchUser>();
  const [searchedValueDriver, setSearchedValueDriver] =
    React.useState<IOnSearchUser>();

  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    province: "",
    city: "",
    parent: "",
    driver: "",
    school: "",
    cycle: "",
  });

  const { userInfo } = useContext(Context.UserScreen);

  const companyIdentify = Cookies.get(values.constants.USER.IDENTIFY);

  // !! ===========================================================================================================
  // !!                                              REST API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllParent = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent],
    () =>
      api.post.common.findParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      })
  );

  const getAllDriver = useQuery(
    [values.useQueryKeys.getAllDriver, searchedValueDriver?.searchedValue],
    () =>
      api.post.company.findDriver({
        search: {
          base: searchedValueDriver?.base.value,
          value: searchedValueDriver?.searchedValue,
        },
      })
  );

  const getAllSchool = useQuery(
    [values.useQueryKeys.getAllSchool, searchedValueSchool?.searchedValue],
    () =>
      api.post.common.findSchoolPost({
        search: {
          base: searchedValueSchool?.base?.value,
          value: searchedValueSchool?.searchedValue,
        },
        filters: {
          city: userInfo?.companyInformation?.city,
          province: userInfo?.companyInformation?.province,
        },
      })
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () =>
      api.get.common.getAllCity({
        provinceCode: selectedProvince?.ProvinceCode,
      })
  );

  const getAllArea = useQuery(
    [values.useQueryKeys.locationGetArea, selectedCity],
    () => api.get.common.searchArea({city: selectedCity?._id, limit: 100}),
    {enabled: !!selectedCity}
  )

  const getAllNeighboarhood = useQuery(
    [values.useQueryKeys.locationGetNeighborhood, selectedArea],
    () => api.get.common.searchNeighborhood({town: selectedArea?._id, limit: 100}),
    {enabled: !!selectedArea}
  )

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const submitHandler = () => {
    let dropDownErrorsList = {
      city        : '',
      area        : '',
      cycle       : '',
      school      : '',
      driver      : '',
      parent      : '',
      company     : '',
      province    : '',
      neighborhood: '',
    };
    if(!selectedCity        ) dropDownErrorsList = {...dropDownErrorsList, city        : t('city_is_required'        )};
    if(!selectedArea        ) dropDownErrorsList = {...dropDownErrorsList, area        : t('area_is_required'        )};
    if(!selectedCycle       ) dropDownErrorsList = {...dropDownErrorsList, cycle       : t('cycle_is_required'       )};
    if(!selectedSchool      ) dropDownErrorsList = {...dropDownErrorsList, school      : t('school_is_required'      )};
    if(!selectedDriver      ) dropDownErrorsList = {...dropDownErrorsList, driver      : t('driver_is_required'      )};
    if(!selectedParent      ) dropDownErrorsList = {...dropDownErrorsList, parent      : t('parent_is_required'      )};
    if(!selectedProvince    ) dropDownErrorsList = {...dropDownErrorsList, province    : t('province_is_required'    )};
    if(!selectedNeighborhood) dropDownErrorsList = {...dropDownErrorsList, neighborhood: t('neighborhood_is_required')};
    setDropDownErrors(dropDownErrorsList);
    if (
      selectedArea      &&
      selectedCity      &&
      selectedCycle     &&
      selectedDriver    &&
      selectedParent    &&
      selectedSchool    &&
      selectedProvince  &&
      selectedNeighborhood
    ) {
      if (!companyIdentify) return utils.errorHandler(9013);
      props.onSubmit({
        city        : selectedCity,
        area        : selectedArea,
        cycle       : selectedCycle,
        school      : selectedSchool,
        parent      : selectedParent,
        driver      : selectedDriver,
        company     : { _id: companyIdentify },
        province    : selectedProvince,
        neighborhood: selectedNeighborhood,
      });
    }
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  const AllParentWithCompleteName = getAllParent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );
  const AllDriverWithCompleteName = getAllDriver?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  const parentPropertyPath =
    values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE.map(
      (item) => {
        switch (item.value) {
          case "PHONE_NUMBER":
            return { ...item, value: "phoneNumber", base: "PHONE_NUMBER" };
          case "FIRST_NAME":
            return { ...item, value: "firstName", base: "FIRST_NAME" };
          case "LAST_NAME":
            return { ...item, value: "lastName", base: "LAST_NAME" };
        }
      }
    );

  const driverPropertyPath =
    values.dropdownBaseSearch.DRIVER_BASE_SEARCH_SUPERAGENT.map((item) => {
      switch (item.value) {
        case "PHONE_NUMBER":
          return { ...item, value: "phoneNumber", base: "PHONE_NUMBER" };
        case "FIRST_NAME":
          return { ...item, value: "firstName", base: "FIRST_NAME" };
        case "LAST_NAME":
          return { ...item, value: "lastName", base: "LAST_NAME" };
        case "NATIONAL_CODE":
          return {
            ...item,
            value: "driverInformation.nationalCode",
            base: "NATIONAL_CODE",
          };
      }
    });

  const provinceFiltered = getAllProvince?.data?.result?.filter((item: any) =>
    userInfo?.companyInformation?.province?.includes(item?._id)
  );
  const cityFiltered = getAllCity?.data?.result?.filter((item: any) =>
    userInfo?.companyInformation?.city?.includes(item?._id)
  );

  return (
    <form onSubmit={submitHandler}>
      <CustomView.Container className="create-form-content">
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("parent")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.PARENT_BASE_SEARCH_SUPERAGENT.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={AllParentWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedParen(event);
                setDropDownErrors({ ...dropDownErrors, parent: "" });
              }}
              defaultItem={selectedParent}
              searchedValue={searchedValueParent}
              setSearchedValue={setSearchedValueParent}
              placeHolder={t("selectParent")}
              isLoading={getAllParent.isLoading}
              selectedBaseSearch={
                parentPropertyPath.find(
                  (item) => item?.base === searchedValueParent?.base.value
                )?.value
              }
            />
            <div className="error">
              {dropDownErrors.parent !== "" && dropDownErrors.parent}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("school")}</label>

            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SCHOOL_BASE_SEARCH.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={getAllSchool?.data?.result}
              itemName="name"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedSchool(event);
                setDropDownErrors({ ...dropDownErrors, school: "" });
              }}
              defaultItem={selectedSchool}
              searchedValue={searchedValueSchool}
              setSearchedValue={setSearchedValueSchool}
              placeHolder={t("selectSchool")}
              isLoading={getAllSchool.isLoading}
              selectedBaseSearch={searchedValueSchool?.base?.value}
            />
            <div className="error">
              {dropDownErrors.school !== "" && dropDownErrors.school}
            </div>
          </CustomView.Column>
        </CustomView.Row>

        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("province")}</label>
            <CustomDropDownSearch
              isSearch
              items={provinceFiltered}
              itemName="Name"
              onSelectItem={(event: any) => {
                setDropDownErrors({ ...dropDownErrors, province: "" });
                setSelectedProvince(event);
              }}
              placeHolder={t("selectProvince")}
              defaultItem={selectedProvince}
              isLoading={getAllProvince.isLoading}
            />
            <div className="error">
              {dropDownErrors.province !== "" && dropDownErrors.province}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("city")}</label>
            <CustomDropDownSearch
              isSearch
              items={cityFiltered}
              itemName="Name"
              onSelectItem={(event: any) => {
                setSelectedCity(event);
                setDropDownErrors({ ...dropDownErrors, city: "" });
              }}
              placeHolder={t("selectCity")}
              defaultItem={selectedCity}
              isLoading={getAllCity.isLoading}
            />
            <div className="error">
              {dropDownErrors.city !== "" && dropDownErrors.city}
            </div>
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("area")}</label>
            <CustomDropDownSearch
              isSearch
              items={getAllArea?.data?.result?.docs}
              itemName="name"
              onSelectItem={(event: any) => {
                setSelectedArea(event);
                setDropDownErrors({ ...dropDownErrors, area: '' });
              }}
              placeHolder={t("selectArea")}
              defaultItem={selectedArea}
              isLoading={getAllArea.isLoading}
            />
            <div className="error">{dropDownErrors.area !== "" && dropDownErrors.area}</div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("neighborhood")}</label>
            <CustomDropDownSearch
              isSearch
              items={getAllNeighboarhood?.data?.result?.docs}
              itemName="name"
              onSelectItem={(event: any) => {
                setSelectedNeighborhood(event);
                setDropDownErrors({ ...dropDownErrors, neighborhood: '' });
              }}
              placeHolder={t("selectNeighborhood")}
              defaultItem={selectedNeighborhood}
              isLoading={getAllCity.isLoading}
            />
            <div className="error">{dropDownErrors.neighborhood !== "" && dropDownErrors.neighborhood}</div>
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("driver")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.DRIVER_BASE_SEARCH_SUPERAGENT.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={AllDriverWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: ICompanyItem) => {
                setDropDownErrors({ ...dropDownErrors, driver: "" });
                setSelectedDriver(event);
              }}
              defaultItem={selectedDriver}
              searchedValue={searchedValueDriver}
              setSearchedValue={setSearchedValueDriver}
              placeHolder={t("selectDriver")}
              isLoading={getAllDriver.isLoading}
              selectedBaseSearch={
                driverPropertyPath.find(
                  (item) => item?.base === searchedValueDriver?.base?.value
                )?.value
              }
            />
            <div className="error">
              {dropDownErrors.driver !== "" && dropDownErrors.driver}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("serviceFeeCycle")}</label>
            <CustomDropdownSearch
              items={CYCLE.map((item) => ({
                ...item,
                name: t(item.name as string),
              }))}
              itemName="name"
              defaultItem={selectedCycle}
              onSelectItem={(event: any) => {
                setSelectedCycle(event);
                setDropDownErrors({ ...dropDownErrors, cycle: "" });
              }}
              placeHolder={t("selectServiceFeeCycle")}
            />
            <div className="error">
              {dropDownErrors.cycle !== "" && dropDownErrors.cycle}
            </div>
          </CustomView.Column>{" "}
        </CustomView.Row>
        {/* <CustomView.Row className="form-row"></CustomView.Row> */}
        <CustomView.Row className="form-row">
          <CustomView.Column
            medium={6}
            className="form-colum submit-button-relation"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={submitHandler}
              title={t("next")}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </form>
  );
};

export default CompanyStudentRelations;
